import Button from '@atlaskit/button/standard-button';
import styled from '@emotion/styled';

export const LargeAkButton = styled(Button)`
  height: 40px !important; /* stylelint-disable-line declaration-no-important -- overrides the internal styles of AKButton */
  align-items: center !important; /* stylelint-disable-line declaration-no-important -- overrides the internal styles of AKButton */
`;
